<template>
  <q-btn
    v-if="visible"
    size="sm"
    style="min-width: 65px; width: auto"
    class="q-mr-xs btn-brand"
    dense
    :color="computedColor"
    :label="computedLabel"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import DisplayMLResult from '@/utils/DisplayMLResult';
import MachineLearningResult from '@/models/MachineLearning/MachineLearningResult';
import { WaveformTypeLabel } from '@/models/PassageWaveform';

export default defineComponent({
  name: 'MLBadge',
  props: {
    /** Waveform type code ('E','M','G','A','T') or label ('ELF','MAG','GEO','ACC','TMR') */
    type: {
      type: String,
      required: true,
    },
    /** Flat ML prediction (use with confidence prop) */
    prediction: {
      type: Boolean,
      default: undefined,
    },
    /** Flat ML confidence 0–1 (use with prediction prop) */
    confidence: {
      type: Number,
      default: undefined,
    },
    /** Full ML results array (alternative to prediction/confidence) */
    results: {
      type: Array as PropType<MachineLearningResult[]>,
      default: undefined,
    },
  },
  computed: {
    visible(): boolean {
      if (this.results && this.results.length > 0) return true;
      if (this.confidence != null && this.prediction != null) return true;
      return false;
    },
    mlResult(): { color: string; confidence: number } | null {
      if (this.results && this.results.length > 0) {
        return DisplayMLResult(this.results);
      }
      if (this.confidence != null && this.prediction != null) {
        return DisplayMLResult([
          {
            machineLearningAlgorithmId: 0,
            machineLearningResultId: 0,
            prediction: this.prediction,
            confidence: this.confidence,
            weight: 1,
          },
        ]);
      }
      return null;
    },
    typeLabel(): string {
      // Support both single-char codes ('E') and already-resolved labels ('ELF')
      return WaveformTypeLabel[this.type] || this.type.toUpperCase();
    },
    computedColor(): string {
      return this.mlResult?.color ?? 'grey';
    },
    computedLabel(): string {
      if (!this.mlResult) return '';
      return this.typeLabel + ' ' + Math.round(this.mlResult.confidence) + '%';
    },
  },
});
</script>
